import { Heading, theme } from '@hhgtech/hhg-components'
import { Container, ContainerProps, Text } from '@mantine/core'
import { useIntl } from 'react-intl'

import { ExpertCard } from 'components/atoms/expertCard'
import { ExpertHeading, ExpertUserSummary } from 'interfaces/types'

import { StyledExpertSection, StyledSeeMore } from './index.styled'
type ExpertSectionProps = {
  expertHeading: ExpertHeading
  expertsPosts: Array<ExpertUserSummary>
} & ContainerProps

export const ExpertSection = ({
  expertHeading,
  expertsPosts,
  ...rest
}: ExpertSectionProps) => {
  const { formatMessage: f } = useIntl()

  return (
    <Container size="lg" mb="xl" {...rest}>
      <StyledExpertSection
        style={{
          marginBottom: 8,
        }}
      >
        <div className="header">
          <Heading tag="h3">{expertHeading?.title}</Heading>
          <Text
            span
            size="p4"
            className="description"
            color={theme.colors.gray600}
            dangerouslySetInnerHTML={{
              __html: expertHeading?.content || '',
            }}
          />
          <StyledSeeMore className="mobile-only" href="/expert">
            <Text size="s5" color={theme.colors.primaryBase} span>
              {f({
                id: 'home.seeMoreExperts',
                defaultMessage: 'Meet the team',
              })}
            </Text>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M7.99945 9.38068L5.45212 6.83334C5.17612 6.55734 4.72812 6.55734 4.45212 6.83334C4.17612 7.10934 4.17612 7.55734 4.45212 7.83334L7.52812 10.9093C7.78878 11.17 8.21078 11.17 8.47078 10.9093L11.5468 7.83334C11.8228 7.55734 11.8228 7.10934 11.5468 6.83334C11.2708 6.55734 10.8228 6.55734 10.5468 6.83334L7.99945 9.38068Z"
                fill="#2D87F3"
              />
            </svg>
          </StyledSeeMore>
        </div>
        {expertsPosts.slice(0, 2).map((expert) => (
          <ExpertCard key={expert.id} expert={expert} />
        ))}
      </StyledExpertSection>
      {/* <div>
        <StyledSeeMore
          className="desktop-only"
          href="/expert"
          style={{ marginBottom: 16 }}
        >
          <Text size="s5" color={theme.colors.primaryBase} span>
            {f({
              id: 'home.seeMoreExperts',
              defaultMessage: 'Meet the team',
            })}
          </Text>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M7.99945 9.38068L5.45212 6.83334C5.17612 6.55734 4.72812 6.55734 4.45212 6.83334C4.17612 7.10934 4.17612 7.55734 4.45212 7.83334L7.52812 10.9093C7.78878 11.17 8.21078 11.17 8.47078 10.9093L11.5468 7.83334C11.8228 7.55734 11.8228 7.10934 11.5468 6.83334C11.2708 6.55734 10.8228 6.55734 10.5468 6.83334L7.99945 9.38068Z"
              fill="#2D87F3"
            />
          </svg>
        </StyledSeeMore>
      </div> */}
      {expertsPosts?.length > 2 && (
        <StyledExpertSection>
          {expertsPosts.slice(2).map((expert) => (
            <ExpertCard key={expert.id} expert={expert} />
          ))}
        </StyledExpertSection>
      )}
    </Container>
  )
}
